import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../redux/store";
import { getUser } from "../../redux/slices/CurrentUserSlice";
import { handleNotificationStatus } from "../../utils/handleNotificationStatus";
import { getNotificationData, getStripeActiveStatus, getStripeStatus } from "../../redux/slices/NotificationAlertSlice";
import NotificationBanner from "./NotificationBannerProps";
import { UserType } from "../../services/user.service";

type Notification = {
  notificationId: string;
  name: string;
  message: string;
  audience: string;
  notificationAlertType: string;
  active: boolean;
  maintenanceStartWindow: string;
  maintenanceEndWindow: string;
  triggeredBy: string;
  roles?: string[];
};
type NotificationResponse = {
  data: Notification[];
};

type StripeData = {
  active: boolean;
  audience: string;
  maintenanceStartWindow: string;
  message: string;
  name: string;
  notificationAlertType: string;
  notificationId: string;
  triggeredBy: string;
};
type StripeResponse = {
  data: StripeData[];
};
interface NotificationItem {
  name: string;
  triggeredBy: string;
  audience: string;
  maintenanceStartWindow: string;
  maintenanceEndWindow: string;
  active: boolean;
  notificationId: string;
  message: string;
  notificationAlertType: string;
  status: string;
  roles?: string[];
  // add other fields as needed
}

const MaintenanceBanner = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [userData, setUserData] = useState<Notification[]>([]);
  const [stripeData, setStripData] = useState<StripeData[]>([]);
  const [notificationData, setNotificationData] = useState<NotificationItem[]>([]);
  const [logInUserResult, setLogInUserResult] = useState<string | null>(null);

  const userChecking = async () => {
    const result = await dispatch(getUser());
    const logInUser = (result.payload as { userType: string })?.userType;
    setLogInUserResult(logInUser);
    const res = (await handleNotificationStatus(dispatch, logInUser)) as NotificationResponse;
    if (logInUser === UserType.Patient) {
      setUserData(res?.data);
      dispatch(getStripeStatus());
      const result = await dispatch(getStripeActiveStatus());
      const payload = result.payload as StripeResponse;
      setStripData(payload.data ? [payload.data[0]] : []);
    } else {
      const filteredNotifications = res?.data?.filter(item => item?.roles?.includes(logInUser));
      if (filteredNotifications && filteredNotifications?.length > 0) {
        setUserData(filteredNotifications);
      }
    }
    if (logInUser === UserType.SystemAdmin) {
      const data = await dispatch(getNotificationData());
      const response = data.payload as { data: NotificationItem[] };
      const filterData = response?.data?.length && response?.data?.filter(item => item.active === true);
      if (filterData) setNotificationData(filterData);
    }
  };
  useEffect(() => {
    userChecking();
  }, []);

  return (
    <>
      {userData?.length > 0 && <NotificationBanner message={userData[0].message} bgColor="#fb5b30" />}
      {stripeData?.length > 0 && stripeData[0]?.active && <NotificationBanner message={stripeData[0].message} bgColor="#0070f3" />}
      {notificationData?.length && logInUserResult === UserType.SystemAdmin && (
        <div className="overflow-hidden relative bg-red-500 text-white !mx-[-20px] py-2 px-5 font-medium group">
          <div className="animate-marquee whitespace-nowrap flex gap-12 group-hover:[animation-play-state:paused]">
            {notificationData?.map((item, i) => (
              <div key={i} className="flex">
                {item?.roles?.length ? (
                  item?.roles?.map((val, i) => {
                    return (
                      <div key={i}>
                        &nbsp; {val} &nbsp;
                        {i !== (item.roles?.length ?? 0) - 1 && "|"}
                      </div>
                    );
                  })
                ) : (
                  <>{item?.audience} &nbsp;</>
                )}
                : {item?.message}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default MaintenanceBanner;
